import { Component, Injectable, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/helpers/authentication.service';
import { User } from 'app/helpers/user.model';
import { NotificationsService } from 'app/main/a2w/notifications/services/notifications-aniversario.service';
import { NotificationsAtividadesService } from 'app/main/a2w/notifications/services/notifications-atividades.service';
import { navigation } from 'app/navigation/navigation';
import { ConfigVersion } from 'app/shared/config-version.service';
import { EnumFuncoes, FuncoesApelidos } from 'app/shared/enum.service';
import { UsuarioService } from 'app/shared/usuario.service';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ToolbarService } from './toolbar.service';




@Injectable({
    providedIn: 'root'
  })

@Component({
    selector     : 'toolbar',
    templateUrl  : './toolbar.component.html',
    styleUrls    : ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];

     public  theme: any;
    typeTheme: any;
    funcao = ''; 
    versaoPlataforma: string = '';
    intervaloVerificacao: any;
    qtdNotificacoes: number = 0;
    qtdAniversario: number = 0;
    qtdAtividade: number = 0;
    user: User = new User();

    qtdNotificacoes$ = this._toolbarService.qtdNotificacoes$;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private _authService: AuthenticationService,
        public _toolbarService: ToolbarService,
        private route: Router,
        private _usuarioService: UsuarioService,
        private _notificationsAtividadesService: NotificationsAtividadesService,
        private _notificationsService: NotificationsService,
        private _configVersion: ConfigVersion,
        private _route: Router
    )
    {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon : 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon : 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon : 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id   : 'en',
                title: 'English',
                flag : 'us'
            },
            {
                id   : 'tr',
                title: 'Turkish',
                flag : 'tr'
            }
        ];
        this._fuseConfigService.getConfig().subscribe(res => {
            this.typeTheme = res;
        });

        this.versaoPlataforma = _configVersion.versionPlataforma;

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit(): Promise<void>
    {

        await this._toolbarService.verificaNotificacoes();
        
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        this._route.events.pipe(
                takeUntil(this._unsubscribeAll),
                filter(event => event instanceof NavigationEnd)
                ).
                subscribe( async () => {
                    
                await this._toolbarService.verificaNotificacoes();
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});

        if (this._authService.currentUserValue){

            this.user = this._authService.currentUserValue;            

            if (this.user.userDetails.userRules){
                const regraAtiva = this.user.userDetails.userRules.find(x => x.ativo);
                if (regraAtiva) {
                    this.funcao = FuncoesApelidos[regraAtiva.funcao as EnumFuncoes]; 
                }
            }
            this._usuarioService.getUserPreferences(this.user.userDetails.userId).then(res => {
                if (res){
                                                
                    if (res.themeDark == 0){    

                        this.theme = 'Tema Escuro';
                        this.typeTheme.colorTheme = 'theme-green-light';
                        this.typeTheme.layout.navbar.primaryBackground = 'primary-50';
                        this.typeTheme.layout.navbar.secondaryBackground = 'white';                                 
                        this._fuseConfigService.setConfig(this.typeTheme);         
                                                                    
                    }
                    else{                                    
            
                        this.theme = 'Tema Claro';
                        this.typeTheme.colorTheme = 'theme-green-dark';
                        this.typeTheme.layout.navbar.primaryBackground = 'black';
                        this.typeTheme.layout.navbar.secondaryBackground = 'black';                                               
                        this._fuseConfigService.setConfig(this.typeTheme);    
                    }
                }
            });

            if (this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.Administrador).ativo ||
                this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.Gestor).ativo ||
                this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.VendedorBalcão).ativo ||
                this._authService.currentUserValue.userDetails.userRules.find(userRules => userRules.funcao == EnumFuncoes.VendedorCampo).ativo) {

                await this._toolbarService.verificaNotificacoes();

                this.intervaloVerificacao = setInterval(async () => {
                    await this._toolbarService.verificaNotificacoes();
                }, 1800000); // 30 minutos
            }

        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();

        if (this.intervaloVerificacao) {
            clearInterval(this.intervaloVerificacao);
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void
    {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void
    {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }

    logout() {
        this._authService.logout();
        this.route.navigate(['pages/auth/login-2']);
    }

    meuPerfil(){
        this.route.navigate(['a2w/perfil-user']);               
    }

    notification(){
        this.route.navigate(['a2w/notifications']);  
    }

    laraIA() {
        const url = this.route.serializeUrl(
            this.route.createUrlTree(['a2w/lara/lara-menu'])
        );
        window.open(url, '_blank'); 
    }

    async changeTheme(){
                
        const obj = {
            'userId': this._authService.currentUserValue.userDetails.userId,
            'themeDark': 0
        };        

        if (this.typeTheme.colorTheme == 'theme-green-light'){ 
            obj.themeDark = 1;
            
            this._usuarioService.updateUserPreferences(obj);               
            this.theme = 'Tema Claro';
            this.typeTheme.colorTheme = 'theme-green-dark';
            this.typeTheme.layout.navbar.primaryBackground = 'black';
            this.typeTheme.layout.navbar.secondaryBackground = 'black';                
            await this._fuseConfigService.setConfig(this.typeTheme);    
                                
        }
        else{    

            this._usuarioService.updateUserPreferences(obj);            
            this.theme = 'Tema Escuro';
            this.typeTheme.colorTheme = 'theme-green-light';
            this.typeTheme.layout.navbar.primaryBackground = 'primary-50';
            this.typeTheme.layout.navbar.secondaryBackground = 'white';                 
            await this._fuseConfigService.setConfig(this.typeTheme);            
        }
        
    }
}
